import React from 'react';
import { Layout, Typography, Row, Col, Card } from 'antd';
import { Outlet } from 'react-router-dom';
const { Title } = Typography;

const AuthLayout: React.FC = () => {
  return (
    <Layout className="card-login">
      <Outlet />
    </Layout>
  );
};

export default AuthLayout;
